import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductLineEntityParams {
  productLineId: number;
}
export class ProductLineEntity extends BaseEntityClass {
  productLineId: number;
  constructor(params: ProductLineEntityParams) {
    super();
    this.type = "product_line";
    this.entity_version = 2;
    this.productLineId = params.productLineId;
  }
}
